export const DAYS_PER_WEEK = 7;
export const DAYS_PER_MONTH = 31;
export const DAYS_PER_TWO_MONTH = 62;
export const DAYS_PER_THREE_MONTH = 90;
export const DAYS_PER_FOUR_MONTH = 121;
export const DAYS_PER_FIVE_MONTH = 152;
export const DAYS_PER_SIX_MONTH = 182;
export const DAYS_PER_SEVEN_MONTH = 212;
export const DAYS_PER_EIGHT_MONTH = 243;
export const DAYS_PER_NINE_MONTH = 273;
export const DAYS_PER_TEN_MONTH = 304;
export const DAYS_PER_ELEVEN_MONTH = 334;
export const DAYS_PER_YEAR = 365;

export enum ProductCodes {
    APP_FULL_ACCESS = 'app_full_access',

    /** Upsells */
    MEAL_PLAN_WORKOUTS_PACK = 'meal_plan_workouts_pack',
    MEAL_PLANNER = 'meal_planner',
    WORKOUT_PACK = 'workout_pack',
    WORKOUT_BUNDLE_LIFETIME = 'workout_bundle_lifetime',
    ABS_WORKOUT = 'abs_workout',
    MOBILITY_STRETCHING = 'mobility_stretching',
    DANCING_WORKOUT = 'dancing_workout',
    FAT_BURNING_INTERVAL = 'fat_burning_interval',
    NUTRITION = 'nutrition',
}

export const PRODUCT_CODE_TYPES = {
    MAIN_SUBSCRIPTION: 'main_subscription',
    UPGRADE_SUBSCRIPTION: 'upgrade_subscription',
    UPSELL_SUBSCRIPTION: 'upsell_subscription',
    UPSELL_ONETIME: 'upsell_onetime',
};

export const SUBSCRIPTION_ACTIVE = 'active';
export const SUBSCRIPTION_REDEMPTION = 'redemption';
export const SUBSCRIPTION_CANCELLED = 'cancelled';
export const SUBSCRIPTION_CHARGEBACK = 'chargeback';
export const SUBSCRIPTION_PAUSED = 'paused';
export const SUBSCRIPTION_PENDING = 'pending';
export const SUBSCRIPTION_PENDING_FAILED = 'pending_failed';

export const SPECIAL_OFFERS = {
    DISCOUNT: 'discount',
    PAUSE_SUBSCRIPTION: 'pause',
    FREE_MONTH: 'free_month',
} as const;
